import { create, doMocked, isMocked } from "../api";
import { key } from "./action";

export const SERVICE_ENDPOINT = "users";
export const SERVICE_ENDPOINT_CREATE_USER = `${SERVICE_ENDPOINT}/`;

export const createUser = (body) => {
  if (isMocked()) return doMocked(key, SERVICE_ENDPOINT_CREATE_USER);
  return create(`${SERVICE_ENDPOINT}`, body);
};
